import { Component, Input } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatInputModule } from 'src/app/shared/material';
import { Subscription } from 'rxjs';
import { DynamicFormControl } from '../../models/dynamic-form-control.model';
import { FilterService } from 'src/app/shared/filtering';
import { DYNAMIC_ERROR_STATE_MATCHER } from '../../services/dynamic-control-error-state-matcher';

@Component({
    selector: 'lib-text-box-control',
    imports: [ReactiveFormsModule, FormsModule, MatInputModule],
    templateUrl: './text-box-control.component.html',
    styleUrl: './text-box-control.component.scss'
})
export class TextBoxControlComponent {
  @Input() control: DynamicFormControl;
  @Input() isReadonly: boolean;
  inputControl: FormControl;
  errorStateMatcher = DYNAMIC_ERROR_STATE_MATCHER;

  private _subscriptions: Subscription[] = [];

  /**
   * Drives the Material required-asterisk explicitly instead of relying on
   * Material's implicit validator detection, which fails to render the asterisk
   * for controls that stay empty (e.g. a disabled, pre-populated field with no
   * value) because no `stateChanges` event is emitted to refresh the form field.
   */
  get isRequired(): boolean {
    return (
      this.control?.customOptions?.isRequired ||
      this.inputControl?.hasValidator(Validators.required) ||
      false
    );
  }

  constructor(private filterService: FilterService) {}

  ngOnInit() {
    this.inputControl = this.control.formControls[0].formControl;

    let sub = this.filterService.activeFilterRemoved$.subscribe({
      next: (i) => {
        if (i.propertyBinding === this.control.propertyBinding) {
          this.control.formControls[0].formControl.setValue(null);
        }
      },
      error: (e) => console.log(e),
    });

    this._subscriptions.push(sub);
  }

  ngOnDestroy() {
    this._subscriptions.forEach((i) => i.unsubscribe());
  }
}
